import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { CenterObject } from '@it2go/types';
import { OrganizationCentersTableStore } from './organization-centers-table.store';
import { isAllowed, routeParams } from '../../../../shared/shared.global-service';
import { ConfirmBuilder } from '../../../../shared/service/confirm.builder';
import { checkOk } from '../../../content.error';

import { CardTableComponent } from '../../../../shared/components/kit/table/card-table.component';
import { Dialog } from '@openng/optimus-ui/dialog';
import { CenterBasicInfosComponent } from '../center-basic-info/center-basic-infos.component';
import { TranslatePipe } from '@ngx-translate/core';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { CurrentValidPipe } from '../../../../shared/pipes/currentValid.pipe';
import { ShortDatePipe } from '../../../../shared/pipes/short-date.pipe';
import { FormatPersonPipe } from '../../../../shared/pipes/format-person.pipe';

@Component({
    selector: 'app-organization-centers-table',
    templateUrl: './organization-centers-table.component.html',
    styleUrls: ['./organization-centers-table.component.scss'],
    providers: [OrganizationCentersTableStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CardTableComponent,
        Dialog,
        CenterBasicInfosComponent,
        TranslatePipe,
        PrimeTemplate,
        CurrentValidPipe,
        ShortDatePipe,
        FormatPersonPipe,
    ],
})
export class OrganizationCentersTableComponent {
    protected readonly store = inject(OrganizationCentersTableStore);
    private readonly router = inject(Router);


    protected readonly confirmBuilder = inject(ConfirmBuilder);

    @Input() centres: CenterObject[] = [];

    createCenterModalVisible = false;

    protected async createCenter() {
        this.createCenterModalVisible = true;
    }

    closeCreateCenterModal() {
        this.createCenterModalVisible = false;
    }

    protected async detailCenter(center: CenterObject) {
        const organizationId = routeParams.organizationId();
        await this.router.navigateByUrl(`content/organizations/${organizationId}/centers/${center.id}`);
    }

    protected async deleteCenter(event: any) {
        this.confirmBuilder.confirmDelete(
            async () => {
                checkOk(await this.store.api.deleteCenter(event.item.id));
            },
            event,
        );
    }

    protected readonly isAllowed = isAllowed;
}
